



































































































import Modal from "../core/Modals/Modal.vue";
import { ImportMetadataApi } from "../api/ImportMetadataApi";
import { ImportMetadata } from "../models/ImportMetadata";

export default {
    name: "ProcessedDocumentDetailModal",
    components: { Modal },
    props: {
        showModal: Boolean,
        importMetadata: ImportMetadata,
    },
    data() {
        return {
            ImportMetadataApi: new ImportMetadataApi(),
        };
    },
    computed: {
        isResultArray() {
            return (
                this.importMetadata &&
                this.importMetadata.result &&
                Array.isArray(this.importMetadata.result)
            );
        },
        formattedResult() {
            if (!this.importMetadata || !this.importMetadata.result) {
                return "";
            }

            if (typeof this.importMetadata.result === "object") {
                // Use the syntaxHighlight method to format the JSON
                return this.syntaxHighlight(this.importMetadata.result);
            }

            return this.importMetadata.result;
        },
        tableHeaders() {
            if (!this.isResultArray || !this.importMetadata.result.length) {
                return {};
            }

            // Get all unique keys from all items in the array
            const headers = {};
            this.importMetadata.result.forEach((item) => {
                Object.keys(item).forEach((key) => {
                    headers[key] = true;
                });
            });

            return headers;
        },
    },
    methods: {
        closeModal: function (data): void {
            this.$emit("close-modal");
        },
        getStatusLabel: function (status): string {
            const statusMap = {
                0: "En attente",
                1: "En cours",
                2: "Succès",
                3: "Erreur",
                4: "Doublon",
            };

            return statusMap[status] || `Status inconnu (${status})`;
        },
        syntaxHighlight: function (json): string {
            // Make sure we have a string
            if (typeof json !== 'string') {
                json = JSON.stringify(json, null, 4);
            }

            // Format the JSON with better spacing and structure
            try {
                // Parse and re-stringify to ensure proper formatting
                const obj = JSON.parse(json);

                // Use 4 spaces for indentation for better readability
                return JSON.stringify(obj, null, 4);
            } catch (e) {
                console.error("Error parsing JSON in syntaxHighlight:", e);
                return json; // Return the original if there's an error
            }
        },
    },
};
